import { Component, OnInit } from '@angular/core';

import { Detection } from '../../../../../people/models/detection.interface';
import { DetectionService } from '../../../../services/detection.service';
import { SidebarService } from 'src/app/services/sidebar.service';

@Component({
  selector: 'app-detection-detail',
  templateUrl: './detection-detail.component.html',
  styleUrls: ['./detection-detail.component.scss'],
})
export class DetectionDetailComponent implements OnInit {
  public detection: Detection;
  public image: Blob;
  private _isDetectionSidebarOpen: boolean;

  constructor(
    private detectionService: DetectionService,
    private sidebarService: SidebarService
  ) {}

  ngOnInit() {
    this.detectionService.selectedDetection$.subscribe(detection => {
      this.detection = detection;
    });
    this.detectionService.selectedDetectionImage$.subscribe(image => {
      this.image = image;
    });
    this.subscribeToDetectionSidebar();
  }

  public get isDetectionSidebarOpen(): boolean {
    return this._isDetectionSidebarOpen;
  }

  public set isDetectionSidebarOpen(value: boolean) {
    this.sidebarService.setDetectionSidebarOpen(value);
  }

  private subscribeToDetectionSidebar() {
    this.sidebarService.detectionSidebarOpen$.subscribe(isOpened => {
      this._isDetectionSidebarOpen = isOpened;
    });
  }
}
